module.exports = __webpack_public_path__ + "img/partA3.a8d1ca41.png";